import React from 'react';
import styled from '@emotion/styled/macro';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import IconButton from '@mui/material/IconButton';
import NavLink from 'components/NavLink';
import { isMobile } from 'helpers';
import PropTypes from 'propTypes';

const HeaderWrapper = styled('div')`
  position: fixed;
  top: ${isMobile ? 0 : '52px'};
  left: 0;
  width: 100%;
  min-height: ${isMobile ? '56px' : '64px'};
  padding: 0 1rem;
  background: #fff;
  color: #666;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  z-index: ${({ theme }) => theme.zIndex.fullScreenHeader};

  display: grid;
  grid-template-columns: minmax(max-content, 1fr) auto minmax(max-content, 1fr);
  grid-column-gap: ${({ theme }) => theme.spacing(2)};
`;

const HeaderItem = styled('div')`
  display: flex;
  height: 100%;
  align-items: center;
`;

const LeftGridItem = styled(HeaderItem)`
  justify-content: flex-start;
`;

const CenterGridItem = styled(HeaderItem)`
  justify-content: center;
  grid-column: 2;

  max-width: 100%;
  overflow: hidden;
`;

const RightGridItem = styled(HeaderItem)`
  justify-content: flex-end;
  grid-column: 3;
`;

const HeaderTitle = styled('div')`
  font-weight: 600;
  font-size: 0.9rem;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FullScreenHeader = ({ backUrl, title, rightComponent }) => {

  return (
    <HeaderWrapper>

      <LeftGridItem item>
        <IconButton component={NavLink} size="small" to={backUrl}><ArrowBackIosRoundedIcon /></IconButton>
      </LeftGridItem>

      <CenterGridItem item>
        <HeaderTitle>{title}</HeaderTitle>
      </CenterGridItem>

      <RightGridItem item>
        {rightComponent}
      </RightGridItem>

    </HeaderWrapper>
  );
};

FullScreenHeader.propTypes = {
  backUrl: PropTypes.string,
  title: PropTypes.string,
  rightComponent: PropTypes.any,
};

export default FullScreenHeader;
